import { styled } from "@linaria/react"

import { UserMessageContainer } from "@/components/Chat/UserMessageStyles.ts"

export const AgentMessageContainer = styled.div<{
  isActive?: boolean
}>`
  margin-bottom: 24px;

  & + ${UserMessageContainer} {
    margin-top: 40px;
  }

  ${UserMessageContainer} + & {
    margin-top: 24px;
  }

  transition: 0.2s opacity ease-in-out;
  opacity: ${props => props.isActive ? 1.0 : 0.5};
`

export const VersionContainer = styled(AgentMessageContainer)`
  display: flex;
  justify-content: center;
`